import React from "react";
import HeroSection from "../components/HeroSection";
import DownloadAppBanner from "../components/DownloadAppBanner";

import rotiImg from "../assets/images/roti-1.jpg";
import CategorySection from "../components/CategorySection";
import DealsSection from "../components/DealsSection";
import Product1 from "../components/Product1";
import Product2 from "../components/Product2";
import ServiceSection from "../components/ServiceSection";
import AllProduct from "../components/AllProduct";

export default function Home() {
    return (
        <>
            <HeroSection />

            <CategorySection />
            <DealsSection />
            <Product1 />
            {/* <Product2 /> */}
            <ServiceSection />
            <DownloadAppBanner />
            <AllProduct />
        </>
    );
}
